<script setup lang="ts">

import OnboardingSteps from '@/components/OnboardingSteps.vue'
import type { OnboardingStep } from '@/types/onboarding'
import { ref } from 'vue'
import router from '@/router'
import { useOnboardingLayout } from '@/composables/game/onboarding'

const { steps } = useOnboardingLayout()
const currentStep = ref<OnboardingStep>(steps[0])

function goNext() {
  if (currentStep.value.index !== steps.length - 1) {
    currentStep.value = steps[currentStep.value.index + 1]
  } else {
    router.back()
  }
}
</script>

<template>
  <div
    class="flex-1 flex flex-col"
  >
    <OnboardingSteps
      :current-step="currentStep"
      :steps="steps"
      @set-step="currentStep = steps[$event]"
      @go-next="goNext"
    />
  </div>
</template>

<style scoped>

</style>